import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import{Link} from "react-router-dom";
const Gallery = ({ galleryArray }) => {

  const [searchText, setSearchText] = useState("");

  const filteredArray = galleryArray && galleryArray.filter(
    ({ title, heading, content, tags, link }) =>
      title.toLowerCase().includes(searchText.toLowerCase()) ||
      heading.toLowerCase().includes(searchText.toLowerCase()) ||
      content.toLowerCase().includes(searchText.toLowerCase()) ||
      (tags && tags.toLowerCase().includes(searchText.toLowerCase())) ||
      link.toLowerCase().includes(searchText.toLowerCase())
  );
 
  const itemsByHeading = filteredArray?.reduce((groups, item) => {
    const { heading } = item;
    (groups[heading] = groups[heading] || []).push(item);
    return groups;
  }, {});

  const accordionItems = itemsByHeading ? Object.entries(itemsByHeading).map(
    ([heading, items], index) => {
      const id = `a${index}`;
      return (
        <li key={index} id="list">
          <input type="radio" className="radio" name="accordion" id={id} />
          <label htmlFor={id}>
            {index + 1}. {heading}
          </label>
          <div className="content" id="content">
            {items.map((item, i) => (
              <div key={i} className="toolCard" id="toolCard">
                <h2 className="card__title">{item.title}</h2>
                <p className="card__content">{item.content}</p>
                <div className="card__date">Tags {item.tags}</div>
                <a href={item.link} target="_blank" rel="noreferrer">
                  <div className="card__arrow">
                    <i className="fa-solid fa-arrow-right-long"></i>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </li>
      );
    }
  ) : [];
  const result = filteredArray.length;
  const searchBar = document.getElementById("searchBar");
  const [isActive, setIsActive] = useState(false);

  function handleClick() {
    setIsActive(!isActive);
  }
 
  return (
    <div>
      <Helmet>
        <title>Link Library -A Curated Collection of Must-Visit Websites </title>
        <meta property="og:title" content="DesireStore - Secure and Fast Software, Games, Android APKs, Bookmarker and Link Library"/>
        <meta property="og:site_name" content="Desire Store"/>
        <meta property="og:url" content="https://desirestore.online/LinkLibrary"/>
        <meta property="og:description" content="Discover a wide range of essential online tools and resources for students in our link library. From resume builders and PDF converters to Instagram tools and logo makers, we've got you covered. Plus, with free cloud storage, background removers, CSS icons, and typing lessons, you'll find everything you need to excel in the digital age. Explore our link library today!"/>
        <meta property="og:type" content="website"/>
        <meta property="og:image" content="og-images/og-home.png"/>

        <link rel="canonical" href="https://desireStore.online/LinkLibrary" />
        <meta name="title" content="Link Library -A Curated Collection of Must-Visit Websites"/>
        <meta name="description" data-rh="true" content="Discover a wide range of essential online tools and resources for students in our link library. From resume builders and PDF converters to Instagram tools and logo makers, we've got you covered. Plus, with free cloud storage, background removers, CSS icons, and typing lessons, you'll find everything you need to excel in the digital age. Explore our link library today"/>
        <meta name="keywords" content="online tools, resources, services, students, resume builder, PDF converter, student section, certificates, Instagram tools, logo maker, cloud storage, background remover, CSS icons, typing lessons."/>
      </Helmet>
        <div className="container">
        <div className="hero" id="hero">
        <div className="left-hero">
          
        <h3>Your one-stop shop for all your website needs!</h3>
      <p id="low">Explore Our collection of <span id="cow">{galleryArray.length}</span> websites </p>
      </div>
    <div className="right-hero">
           <div className={`search ${isActive ? '' : 'active'}`}>
          <div className="icon" onClick={handleClick}></div>
          <div className="input">  <input type="search" id="searchBar" placeholder="Search Websites..." onChange={(e) => setSearchText(e.target.value)} /></div> 
          </div>
<p style={{ display: searchBar && searchBar.value ? "block" : "none" }}>( {result} Results Found)</p>
</div>
      </div>
    
    
      
      <div id="notfound"style={{ display: filteredArray.length === 0 && searchText !== "" ? "block" : "none" }} >
       <div className="notfound">
         <h2>Sorry, this item is unavailable right now </h2>
          <div className="notfound-404">
            <h1>Oops!</h1>
            <h2>This item not found</h2>
          </div>
          <Link to={"/contact"}>Request Website</Link>
        </div>
      </div>
      <ul className="accordion" id="accordion">
        {accordionItems}
      </ul>
    </div></div>
  );
};

export default Gallery;
